

























































































































































































































































































import { Component, Prop, Inject, Watch, Vue } from "vue-property-decorator";
import { IExcursion } from "@/@types/excursions/excursions";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import { ILocale } from "@/@types/locale";
import { IExcursionCoast } from "@/@types/excursions/excursions";
import { IWorkTimetable } from "@/@types/excursions/excursions";
import { Geometry } from "@/@types/wiki/geojson";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import ExcursionDemo from "@/components/demo/excursion/excursion-demo.vue";
import ChangeExcursionMarker from "@/components/card/excursion/change-excursion-marker.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartCategoryDd from "@/components/app/dropdowns/standart-category-dd.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import ExcursionCoastForm from "@/components/forms/excursion/excursion-coast-form.vue";
import ExcursionWorkTimetabl from "@/components/forms/excursion/excursion-work-timetable.vue";
import ButtonLocales from "@/components/buttons/button-locales.vue";
import VueTimepicker from "vue2-timepicker";
import StandartModal from "@/components/app/standart-modal.vue";

interface ITimepicker {
  HH: string;
  mm: string;
}

@Component({
  components: {
    StandartModal,
    "excursion-work-timetable": ExcursionWorkTimetabl,
    ChangeExcursionMarker,
    SubmitResetButtonGroop,
    UploadPicture,
    StandartCategoryDd,
    ExcursionCoastForm,
    CloseButton,
    InputSearch,
    VueEditor,
    BSwitch,
    MainDemo,
    ExcursionDemo,
    ButtonLocales,
    VueTimepicker,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    category: { required },
    short_description: { maxLength: maxLength(250) },
  },
})
export default class ChangeExcursionForm extends Vue {
  @Prop({ type: Object, default: null }) item!: IExcursion;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;

  @Inject({ from: "excursionFolder", default: null }) readonly folder!: string;
  @Inject({ from: "excursionBgFolder", default: null }) readonly bg!: string;

  name = "";
  names: ILocale = {};
  description = "";
  descriptions: ILocale = {};
  short_description = "";
  short_descriptions: ILocale = {};
  place = "";
  places: ILocale = {};
  coasts: Array<IExcursionCoast> = [];
  work_timetable: Array<IWorkTimetable> = [];

  show = true;
  awaliblelity = true;
  included = false;
  category = "";
  poster = "";
  image = "";
  lat = 0;
  lon = 0;
  duration: ITimepicker | null = null;
  locale = this.$store.getters.getLanguages[0];

  auto_find_short_descriptions = true;

  get excursion(): Partial<IExcursion> {
    return {
      _id: this.item ? this.item._id : "",
      show: this.show,
      awaliblelity: this.awaliblelity,
      included: this.included,
      duration: this.duration_ms,
      category: this.category,
      groups: [],
      name: this.names,
      description: this.descriptions,
      short_description: this.short_descriptions,
      params: this.coasts,
      work_timetable: this.work_timetable,
      adress: {
        lat: this.lat,
        lon: this.lon,
        place: this.places,
      },
      src: {
        poster: this.poster,
        image: this.image,
      },
    };
  }

  get location(): Partial<Geometry> {
    const coordinates = this.lat && this.lon ? [this.lon, this.lat] : [];
    return {
      type: "Point",
      coordinates,
    };
  }

  get duration_ms(): number {
    if (!this.duration) return 0;
    const mm = parseInt(this.duration.mm);
    const hh = parseInt(this.duration.HH);
    return mm * 60000 + hh * 3600000;
  }

  @Watch("name")
  entryFolderName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("description")
  entryDescription(): void {
    this.descriptions[this.locale] = this.description;
    if (this.auto_find_short_descriptions && this.description.length < 251)
      this.short_description = this.description;
  }

  @Watch("short_description")
  entryShortDescription(): void {
    this.short_descriptions[this.locale] = this.short_description;
  }

  @Watch("place")
  entryPaleseName(): void {
    this.places[this.locale] = this.place;
  }

  @Watch("locale")
  createStartDatas(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    if (this.short_descriptions)
      this.short_description = this.short_descriptions[this.locale]
        ? this.short_descriptions[this.locale]
        : "";
    else this.short_description = "";
    if (this.places)
      this.place = this.places[this.locale] ? this.places[this.locale] : "";
    else this.place = "";
  }

  getDuration(): void {
    const ms = this.item.duration;
    if (!ms) return;
    const seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    minutes = minutes - hours * 60;
    const duration: ITimepicker = {
      HH: String(hours),
      mm: String(minutes),
    };
    this.duration = duration;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    const id = this.item ? this.item._id : "";
    this.$emit("change", this.excursion, id);
  }

  onReset(): void {
    this.name = "";
    this.names = {};

    this.description = "";
    this.descriptions = {};

    this.short_description = "";
    this.short_descriptions = {};

    this.show = false;
    this.awaliblelity = false;
    this.included = false;
    this.category = "";

    this.poster = "";
    this.image = "";
    this.duration = null;
    this.coasts = [];

    this.place = "";
    this.places = {};
    this.work_timetable = [];
    this.lat = 0;
    this.lon = 0;
    this.locale = this.$store.getters.getLanguages[0];
  }

  startChange(): void {
    this.onReset();
    if (!this.item) return;
    this.category = this.item.category;
    this.names = this.item.name;
    this.descriptions = this.item.description;
    this.short_descriptions = this.item.short_description
      ? this.item.short_description
      : {};
    this.createStartDatas();
    this.show = this.item.show;
    this.awaliblelity = this.item.awaliblelity;
    this.included = this.item.included;
    this.coasts = this.item.params;
    this.poster = this.item.src.poster;
    this.image = this.item.src.image;
    this.places = this.item.adress.place;
    this.work_timetable = this.item.work_timetable;
    this.getDuration();
    if (!this.item.adress) return;
    this.lat = this.item.adress.lat ? this.item.adress.lat : 0;
    this.lon = this.item.adress.lon ? this.item.adress.lon : 0;
  }
}
